export const MOBILE_MAX_WIDTH = 767;

export const MAX_CONTENT_WIDTH = '1130px';

export const GRID_BREAKPOINT_S = '576px';

export const GRID_BREAKPOINT_L = '992px';
